"use client"

import { useCallback } from "react"
import { showNotification } from "@/lib/notifications"

export function useLogout() {
  const performLogout = useCallback(async () => {
    try {
      window.location.replace("/api/auth/logout")
    } catch (err) {
      showNotification({
        type: "error",
        title: "Error while logging out",
        message: (err as any)?.message ?? "Try again in a few seconds or reach your administrator for help.",
      })
    }
  }, [])

  return { performLogout }
}
